import classNames from 'classnames';

export const getActiveState = (active: boolean, reverseOperation?: boolean) => (reverseOperation ? !active : active);

export const getToggleContainerClass = ({
  loading,
  activeState,
  className,
  variant,
  disabled,
}: {
  loading: boolean;
  activeState: boolean;
  className?: string;
  disabled?: boolean;
  variant?: 's' | 'm';
}) =>
  classNames(
    'transition duration-500 rounded-2xl appearance-none cursor-pointer flex items-center shrink-0',
    {
      'cursor-not-allowed pointer-events-none': loading || disabled,
      'fill-dark': activeState && variant === 's',
      'fill-tertiary': activeState && variant === 'm',
      'bg-transparent-12': !activeState,
      'w-10 h-6': variant === 's',
      'w-[56px] h-8 p-1': variant === 'm',
      'opacity-50': disabled,
    },
    className
  );

export const getToggleCircleClass = ({
  activeState,
  loading,
  loadingColor,
  border,
  variant,
}: {
  activeState: boolean;
  loading: boolean;
  loadingColor?: string;
  border?: string;
  variant?: 's' | 'm';
}) =>
  classNames('transition-transform duration-500 ease-in-out transform rounded-2xl flex items-center justify-center', {
    'bg-primary': activeState && !loading && variant === 's',
    'bg-neutral-30 ': !loadingColor && loading,
    [`${loadingColor}`]: loadingColor && loading,
    'translate-x-1': !activeState && !loading,
    'translate-x-3': loading,
    'translate-x-5': activeState && !loading,
    [`${border}`]: border,
    'bg-white': (!activeState && !loading) || variant === 'm',
    'w-4 h-4': variant === 's',
    'w-6 h-6': variant === 'm',
  });
